













import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";
import SlideRadio from "@/components/Com.SlideRadio/index.vue";

@Component({
  components: {
    SlideRadio,
  },
  mixins: [],
})
export default class PureRadioSlide extends Vue {
  @Prop({ type: String }) readonly label!: string;
  @Prop({ type: String, default: "" }) readonly classList!: string;
  @Prop({ type: Array, default: () => [] }) readonly selections!: Array<{
    label: string;
    value: string;
  }>;

  @Model("change") readonly value!: string | boolean;
}
